import { useBaasPlatformCreateAccess } from "../../../../Hooks/useBaasPlatformCreateAccess";
import { BaasInstanceFilterSelect } from "./BaasInstanceFilterSelect";
import { BaasViewAsButton } from "./BaasViewAsControls";

/**
 * Console chrome to the left of the round header icons.
 * Instance dropdown (wide) then "Visualizar como", so view-as sits immediately
 * before dark / notifications / settings. Filter is matriz-only.
 */
export const BaasHeaderControls = () => {
  const { canUseViewAs } = useBaasPlatformCreateAccess();

  return (
    <div className="flex min-w-0 items-center gap-1 sm:gap-1.5">
      <BaasInstanceFilterSelect className="min-w-0" />
      {canUseViewAs ? <BaasViewAsButton className="shrink-0" /> : null}
    </div>
  );
};
